import { render, staticRenderFns } from "./schedule-requests.vue?vue&type=template&id=70b07f43&"
import script from "./schedule-requests.vue?vue&type=script&lang=js&"
export * from "./schedule-requests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports